<template>
  <div class="context-header">
    <div class="row">
      <div v-for="(value, name) in fields" class="col-sm-4">
        <b>{{name}}:</b> {{value}}
      </div>
    </div>
    <vue-plyr :options="{
      iconUrl: `${$ncsConfig.app.relative_url_root}/images/plyr.svg`,
      i18n: {speed: $t('plyr.speed')},
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen', 'download']
    }">
      <audio :src="`${$ncsConfig.app.relative_url_root}/audio/${text.id}.mp3`" preload="none"/>
    </vue-plyr>
  </div>
</template>
<script>
  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      fields() {
        return this.$ncsCsvElementFields(this.document, this.text, this.elements, this.matches)
      }
    }
  }
</script>
<style lang="scss" scoped>
  #context-header-comment {
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    font-size: 0.5rem;
  }
</style>